import React, { useContext } from 'react'
import { ThemeContext } from '../../contexts'
import { NavLink } from 'react-router-dom'
import { MdLocationOn } from 'react-icons/md'

import { TableRowProps } from '../../types'
import Flag from '../Flag/index'
import AddCountryButton from '../AddCountryButton/index'
import './style.scss'

const TableRow = ({
  flags,
  name,
  capital,
  languages,
  population,
  region,
  maps,
  addCountry,
}: TableRowProps) => {
  const { theme } = useContext(ThemeContext)
  const formattedLanguages = languages && Object.values(languages)
  return (
    <tr className="country-info__list" style={{ color: theme.text }}>
      <td>
        <Flag flag={flags.png} name={name} />
      </td>
      <td>{name}</td>
      <td>
        <span className="country-info__legend">Capital:</span>{' '}
        {capital !== undefined ? (
          capital.map((item) => {
            return <>{item}</>
          })
        ) : (
          <>N/A</>
        )}
      </td>
      <td>
        <span className="country-info__legend">Population:</span> {population}
      </td>
      <td className="country-info__languages">
        <span className="country-info__legend">Langauges:</span>
        {formattedLanguages &&
          formattedLanguages.length &&
          formattedLanguages.map((language: any, i) => (
            <li key={i} style={{ color: theme.text }}>
              {language}
              <>{i === formattedLanguages.length - 1 ? '' : ','}</>&nbsp;
            </li>
          ))}
      </td>
      <td>
        <span className="country-info__legend">Region:</span> {region}
      </td>
      <td>
        <span className="country-info__legend">Link to Maps:</span>{' '}
        <a href={`${maps.googleMaps}`} target="blank">
          <MdLocationOn
            className="country-info__location grow"
            height={10}
            width={10}
            aria-hidden="true"
            title="Link to Google Maps"
          />
        </a>
      </td>
      <td className="country-info__button">
        <AddCountryButton addCountry={addCountry} name={name} />
      </td>
      <td className="country-info__infolink">
        <NavLink to={`/countries/${name}`} className="country-info__link">
          <i
            className="fas fa-info-circle fa-2x grow"
            style={{ color: theme.buttonColor }}
          ></i>
        </NavLink>
      </td>
    </tr>
  )
}

export default TableRow
